import { CitesCancelOwnershipAvailableTypeLkp } from '../../api-services/cites/cites-cancel-ownership/CitesCancelOwnershipAvailableTypeLkp';
import { CitesAvailableTypeLkp } from '../../api-services/cites/cites-transfer-ownership/CitesAvailableTypeLkp';
import { Fertilizer, RawMaterial } from '../accreditation/accredit-raw-material-fertilizer-for-import/AccreditRawMaterialFertilizerForImportModels';
import { Lookup, YesNoLkp } from '../common/Lookup';
import { ExportPhytosanitaryCertificateAppendixTypeLookup } from '../export/export-phytosanitary-certificate/ExportPhytosanitaryCertificateTransaction';
import { ImportHorsesCompetitionLookup } from '../import/import-horses/ImportHorsesCompetitionLookup';
import { CitesFalconPassportDetailsLkp } from './CitesFalconPassportDetailsLkp';
import {
  CountryLkp,
  ShippingMethodLkp,
  PortLkp,
  ClassLkp,
  TypeLkp,
  CurrencyLkp,
  FishProcessingTypeLkp,
  MeasureUnitLkp,
  ImportTypeLkp,
  GenderLkp,
  RegisteredFertilizerLkp,
  EndUserPurposesLkp,
  ExportVeterinaryAnimalsFishFeedItemType,
  ExitPortsLkp,
  StorageConditionLkp,
  FishingAreasLkp,
  ProductTemperatureLkp,
  HeatTreatmentTypeLkp,
  SampleSourceLkp,
  TestPurposeLkp,
  YCodeLkp,
  HCodeLkp,
  ACodeLkp,
  UnClassesLkp,
  TransitCountryLkp,
  DisposalMethodLkp,
  DisposalMethodDetailsLkp,
  SampleTypeLkp,
  PackageUnitLkp,
  DescriptionTypeLkp,
  CertifiedForLkp,
  RequestTypeLkp,
  MaterialLkp,
  PurposeOfUseLkp,
  ProductTypeLkp,
  AnimalGenderLkp,
  AnimalClassLkp,
  SubjectLkp,
  ScientificNameLkp,
  QuantityUnitLkp,
  AnimalLkp,
  PharmaceuticalFormLkp,
  AquaticFoodImportPurposeLkp,
  HoneyBeesProductLkp,
  RegisteredProductLkp,
  CompanyTypeLkp,
  RegisteredCompanyLkp,
  MeatTypeLkp,
  MeatCategoryLkp,
  MeatStorageLkp,
  ProductLkp,
  PackageSizeLkp,
  CommonNameLKP,
  CertificateLKP as CertificateLKP,
  FertilizersTypeLkp,
  FertilizerBalanceLkp,
  ExportSourceLkp,
  PesticideBalanceLkp,
  PesticideTypeLkp,
  RegisteredPesticideLkp,
  InorganicSoilKindLkp,
  GrowingMediaKindLkp,
  FertilizerFormLkp,
  AuthorityOwnerLkp,
  InitialTypeLKP,
  ImportPurposeLKP,
  AreaLKP,
  SeedLKP,
  RegistrationTypeLkp,
  RawMaterialTypesLkp,
  RawMaterialLkp,
  CitesTransferTypeLkp,
  CitesBalanceTypeLkp,
  ItemStateLkp,
  SourceLkp,
  INRTypeLkp,
  CitesCancelReasonLkp,
  InitialClassificationLkp,
  PackageTypeLkp,
  SafetyPeriodUnitsLkp,
  AppendixLkp,
  ILookup,
  DispositionTypeLkp,
} from './Lookups';

export class MainLookups {
  countries?: CountryLkp[] = [];
  appendixes?: AppendixLkp[] = [];
  registrationCountries?: CountryLkp[] = [];
  importingCountries?: CountryLkp[] = [];
  birdTransitCountries?: CountryLkp[] = [];
  petsExportTypes?: CountryLkp[] = [];
  originCountries?: CountryLkp[] = [];
  shippingMethods?: ShippingMethodLkp[] = [];
  commoditiesUses?: Lookup[] = [];
  footAndMouthDisease?: Lookup[] = [];
  riftValleyFeverDisease?: Lookup[] = [];
  tuberculosisDisease?: Lookup[] = [];
  brucellosisDiseases?: Lookup[] = [];
  entryPorts?: PortLkp[] = [];
  departurePorts?: PortLkp[] = [];
  classes?: ClassLkp[] = [];
  types?: TypeLkp[] = [];
  currencies?: CurrencyLkp[] = [];
  fishProcessingTypes?: FishProcessingTypeLkp[] = [];

  exportTypes?: ILookup[] = [];
  fishTypes?: TypeLkp[] = [];
  measurementUnits?: MeasureUnitLkp[] = [];
  safetyPeriodUnits?: SafetyPeriodUnitsLkp[] = [];
  importTypes?: ImportTypeLkp[] = [];
  importReasons?: ImportTypeLkp[] = [];
  genders?: GenderLkp[] = [];
  genderNeutered?: GenderLkp[] = [];
  sexes?: Lookup[] = [];
  natureOfCommodities?: Lookup[] = [];
  licensedForHumans?: Lookup[] = [];
  importingCountryAdmissions?: Lookup[] = [];
  meansOfTransports?: Lookup[] = [];
  productHeatTreatments?: Lookup[] = [];
  registeredFertilizers?: RegisteredFertilizerLkp[];
  endUserPurposes?: EndUserPurposesLkp[];
  fishFeedType?: ExportVeterinaryAnimalsFishFeedItemType[];
  exitPorts?: ExitPortsLkp[];
  storageConditions?: StorageConditionLkp[];
  fishingAreas?: FishingAreasLkp[];
  productTemperatures?: ProductTemperatureLkp[];
  heatTreatmentTypes?: HeatTreatmentTypeLkp[];
  heatTreatmentSubTypes?: HeatTreatmentTypeLkp[];

  allClasses?: ClassLkp[] = [];
  competitions?: ImportHorsesCompetitionLookup[];
  disciplines?: Lookup[];
  hospitals?: Lookup[];
  stables?: Lookup[];
  thirdPartyActions?: Lookup[];
  quarantines?: Lookup[];

  testPurposes?: TestPurposeLkp[];
  sampleSources?: SampleSourceLkp[];

  yCodes?: YCodeLkp[];
  hCodes?: HCodeLkp[];
  aCodes?: ACodeLkp[];
  unClasses?: UnClassesLkp[];
  transitCountries?: TransitCountryLkp[];
  disposalMethods?: DisposalMethodLkp[];
  disposalMethodsDetails?: DisposalMethodDetailsLkp[];
  sampleTypes?: SampleTypeLkp[];

  packageUnits?: PackageUnitLkp[];
  descriptionTypes?: DescriptionTypeLkp[];
  certifiedForTypes?: CertifiedForLkp[];
  requestTypes?: RequestTypeLkp[];

  materials?: MaterialLkp[];
  purposeOfUse?: PurposeOfUseLkp[];
  productTypes?: ProductTypeLkp[];
  products?: ProductLkp[];

  animalGenders?: AnimalGenderLkp[];
  animalClasses?: AnimalClassLkp[];
  horsesClasses?: AnimalClassLkp[];
  nonHorsesClasses?: AnimalClassLkp[];
  animalTypes?: Lookup[];
  horsesTransitTypes?: Lookup[];

  subjects?: SubjectLkp[];
  scientificNames?: ScientificNameLkp[];
  quantityUnits?: QuantityUnitLkp[];

  targetAnimals?: AnimalLkp[];
  pharmaceuticalForms?: PharmaceuticalFormLkp[];
  honeyBeesProductTypes?: HoneyBeesProductLkp[];
  aquaticFoodImportPurposes?: AquaticFoodImportPurposeLkp[];
  registeredProducts?: RegisteredProductLkp[];
  registeredPesticides?: RegisteredPesticideLkp[];
  initialClassifications?: InitialClassificationLkp[];
  packageTypes?: PackageTypeLkp[];
  companyTypes?: CompanyTypeLkp[];
  registeredCompanies?: RegisteredCompanyLkp[];
  exportingCountries?: CountryLkp[] = [];
  horsesAllowedCountries?: CountryLkp[] = [];
  exportSources?: ExportSourceLkp[] = [];
  meatTypes?: MeatTypeLkp[] = [];
  meatCategories?: MeatCategoryLkp[] = [];
  meatStorageTypes?: MeatStorageLkp[] = [];
  meatStorageTypesAll?: MeatStorageLkp[] = [];
  companies?: RegisteredCompanyLkp[];
  initiatorActions?: RegisteredCompanyLkp[];
  packageSizes?: PackageSizeLkp[];

  commonNames?: CommonNameLKP[];
  certificates?: CertificateLKP[];
  fertilizerTypes?: FertilizersTypeLkp[];
  fertilizerBalances?: FertilizerBalanceLkp[];
  pesticideTypes?: PesticideTypeLkp[];
  pesticideBalances?: PesticideBalanceLkp[];

  inOrganicSoilKind?: InorganicSoilKindLkp[];
  growingMediakind?: GrowingMediaKindLkp[];
  fertilizerForm?: FertilizerFormLkp[];
  authorityOwners?: AuthorityOwnerLkp[];
  // vaccinationYears?: VaccinationYearLkp[];

  initialTypes?: InitialTypeLKP[];
  beeImportPurposes?: ImportPurposeLKP[];
  beeAreaLocations?: AreaLKP[];
  importedSeeds?: SeedLKP[];
  registerationTypes?: RegistrationTypeLkp[];

  rawMaterialTypes?: RawMaterialTypesLkp[];
  rawMaterials?: RawMaterialLkp[];

  transferTypes?: CitesTransferTypeLkp[];
  balanceTypes?: CitesBalanceTypeLkp[];
  availableTypes?: CitesAvailableTypeLkp[];
  citesCancelOwnershipAvailableTypes?: CitesCancelOwnershipAvailableTypeLkp[];
  reasons?: CitesCancelReasonLkp[];

  INRTypes?: INRTypeLkp[];
  itemStates?: ItemStateLkp[];
  sources?: SourceLkp[];

  deliveryTypes?: Lookup[];
  emirates?: Lookup[];
  regions?: Lookup[];
  falconSources?: Lookup[];
  ringTypes?: Lookup[];

  operationPurposes?: Lookup[];
  certificateTypes?: Lookup[];
  relatedTypes?: Lookup[];

  nationalities?: Lookup[];
  qualifications?: Lookup[];
  areas?: Lookup[];
  engineers?: Lookup[];

  yesNo?: YesNoLkp[];
  readyToEat?: YesNoLkp[];

  tenureMethods?: Lookup[];
  cropTypes?: Lookup[];
  farmingMethods?: Lookup[];
  farmingTechniques?: Lookup[];
  irrigationSystems?: Lookup[];
  geographicalAreas?: Lookup[];
  plantTypes?: Lookup[];
  protectedHouseTypes?: Lookup[];
  serviceCenters?: Lookup[];
  locations?: Lookup[];
  recipients?: Lookup[];
  commodityCodes?: Lookup[];
  compartmentDeclarations?: Lookup[];
  localCompetentAuthorities?: Lookup[];
  requirements?: Lookup[];

  falcons?: CitesFalconPassportDetailsLkp[];
  appendixTypes?: ExportPhytosanitaryCertificateAppendixTypeLookup[];
  establishmentTypes?: Lookup[];
  concernedEntities?: Lookup[];
  licenseTypes?: Lookup[];

  maxAllowedForIndividual?: number;
  individualAnimalCodes?: string[];
  aquaticAnimalsOrigins?: ILookup[];

  productionLineTypes?: Lookup[];
  materialTypes?: ILookup[];
  fertilizersLKP?: Fertilizer[];
  rawMaterialsLKP?:RawMaterial[];
  fertilizerUsages?: ILookup[];
  accompanyDocumentTypes?: ILookup[];

  dispositionTypes?: DispositionTypeLkp[];
  filteredDispositionTypes?: DispositionTypeLkp[];
}

///TODO: move to a new file under export folder
export enum EsExportRequestTypesEnum {
  Export = 'Export',
  ReExport = 'ReExport',
}
